import CustomerHeader from '../../components/CustomerHeader';
import OwnerServicesTab from '../../components/owner/OwnerServicesTab';
import OwnerSidebar from '../../components/owner/OwnerSidebar';


const OwnerServicesScreen = () => {
  return (
    <>
        <section className='dashboard-container flex '>
          <aside className=''>
              <OwnerSidebar />
          </aside>
          <main className='main-container mb-32'>
              <CustomerHeader orderTitle={'Services'} orderSubtitle={'Manage services'} showServicesButton={true}/>

            <section className='mt-20 flex gap-4'>
              <section>
                <OwnerServicesTab/>
              </section>
            </section>
          </main>
        </section>
    </>
    
  )
}

export default OwnerServicesScreen